<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header d-flex justify-content-center">
    <img class="logo-pec" src="{{urlLogo}}" alt="" width="190" height="64">
</div>
<div class="modal-body">
    <div class="row py-3 mb-3 mt-3">
        <div class="col-12 d-flex justify-content-center col-lg-6">
            <div class="card card-body px-3 py-3 pt-4 pb-4 ps-3">
                <div class="row font-weight-normal align-items-center ps-3">
                    <div class="col-5 col-lg-3 font-20 fw-bold "
                        [innerHTML]="'main.modals.pecConversionExpiration.identita.labelIdentita' | translate">
                        Identita
                    </div>
                    <div class="col-6 col-lg-2 text-lg-start">
                           <div class="notIdentified font-12 ps-1 pe-2 w-120px f-r">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong>{{ 'main.modals.pecConversionExpiration.identita.notConfirmed' | translate }}
                            </strong>
                        </div>
                    </div>
                </div>
                <div class="row font-weight-normal align-items-center ps-3">
                    <div>
                        <div>
                            {{ 'main.modals.pecConversionExpiration.identita.messageNotConfirmed' | translate }}
                        </div>
                    </div>
                    <div class="col-12  font-14 text-lg-start mt-2">
                        <svg-icon src="content/images/icons/time-fast.svg"
                            [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
                        <span [innerHTML]="'main.modals.pecConversionExpiration.identita.messageTime' | translate">
                        </span>
                    </div>
                    <div class="col-12 font-14 text-lg-start  mt-2">
                        <svg-icon src="content/images/icons/user-shield-circle.svg"
                            [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'middle' }"></svg-icon>
                        <span [innerHTML]="'main.modals.pecConversionExpiration.identita.messageWhatIsNeeded1' 
                        | translate"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 d-flex justify-content-center col-lg-6 ">
            <div class="card card-body px-3 py-3 pt-4 pb-4 ps-3">
                <div class="row font-weight-normal align-items-center  ps-3">
                    <div class="col-7 col-lg-7 font-20 fw-bold"
                        [innerHTML]="'main.modals.pecConversionExpiration.verifica2Passaggi.labelVerifica2Pass' 
                        | translate">
                    </div>
                    <div class="col-5 col-lg-2 font-16 text-lg-start">
                        <div class="notIdentified font-12 ps-1 pe-2 w-100px f-r" *ngIf="!twoFaEnabled">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong>{{ 'main.modals.pecConversionExpiration.verifica2Passaggi.notEnabled' | translate }}
                            </strong>
                        </div>
                        <div class="confirm font-12 ps-1 pe-2 w-80px f-r" *ngIf="twoFaEnabled">
                            <div class="circleConfirm mr-1 displayInline"></div>
                            <strong>{{ 'main.modals.pecConversionExpiration.verifica2Passaggi.enabled' | translate }}
                            </strong>
                        </div>
                    </div>
                </div>
                <div class="row font-weight-normal align-items-center ps-3">
                    <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="!twoFaEnabled">
                        <div>
                            {{ 'main.modals.pecConversionExpiration.verifica2Passaggi.messageNotEnabled' | translate }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-8 font-14 text-lg-start mt-2" *ngIf="twoFaEnabled">
                        <div>
                            {{ 'main.modals.pecConversionExpiration.verifica2Passaggi.messageEnabled' | translate }}
                        </div>
                        <div class="pl3-2">&nbsp;</div>
                        <div class="pl3-2 pt-23">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer border-top-0 me-0 justify-content-start mt-3 py-5 mb-5 d-none d-lg-block d-md-block">
        <div class="row pe-0 ps-0">
            
            <div class="text-end pe-0">
                <div >
                    <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary" (click)="goToIds()">
                        {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionAlign' | translate }}
                    </button>
                </div>
                <script>
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ 'event': 'GAEvent', 'eventCategory': 'conferma_identita', 'eventAction': 'click',
                        'eventLabel': 'Button - Adegua la tua PEC' });
                </script>
            </div>
        </div>
    </div>
    <div class="modal-footer border-top-0 d-md-none d-flex flex-column">
        <div class="pe-0 ps-0">
            <div class="mt-3">
                 <div>
                    <button type="submit" class="btn btn-lg font-lato fw-bold btn-primary"
                        (click)="goToIds()">
                        {{ 'main.modals.pecConversionExpiration.redStrategy.btnPecConversionAlign' | translate }}
                    </button>
                </div>
                <script>
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ 'event': 'GAEvent',  'eventCategory': 'conferma_identita', 'eventAction': 'click',
                        'eventLabel': 'Button - Adegua la tua PEC' });
                </script>
            </div>
        </div>
    </div>
</div>
